import React from "react";

const variants = {
  confirmed: "text-[#5C8266] bg-[#E2ECE3]",
  completed: "text-[#5C8266] bg-[#E2ECE3]",
  in_progress: "text-[#5E8B91] bg-[#DDE9EA]",
  checked_in: "text-[#5E8B91] bg-[#DDE9EA]",
  held: "text-[#B58A3E] bg-[#F4EAD2]",
  waiting: "text-[#B58A3E] bg-[#F4EAD2]",
  canceled: "text-[#B85C5C] bg-[#F4DEDE]",
  cancelled: "text-[#B85C5C] bg-[#F4DEDE]",
  no_show: "text-[#B85C5C] bg-[#F4DEDE]",
  walk_in: "text-[#3E4F3A] bg-[#E8E1D3]",
};

const labels = {
  confirmed: "Confirmed",
  completed: "Completed",
  in_progress: "In progress",
  checked_in: "Checked in",
  held: "Holding",
  waiting: "Waiting",
  canceled: "Cancelled",
  cancelled: "Cancelled",
  no_show: "No-show",
  walk_in: "Walk-in",
};

export default function StatusChip({ status, label, className = "" }) {
  const key = (status || "held").toLowerCase();
  const v = variants[key] || variants.held;
  const text = label || labels[key] || status;
  return (
    <span
      data-testid={`status-chip-${key}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-pill text-xs font-medium font-ui ${v} ${className}`}
    >
      {text}
    </span>
  );
}
